// extracted by mini-css-extract-plugin
module.exports = {"container":"LotteryResultsTransfer_container__TSQMD","logo":"LotteryResultsTransfer_logo__l_Dvb","button":"LotteryResultsTransfer_button__EK8IV"};